import React, { useEffect, useState } from "react";
import { viewInternLeaveApplications } from "../../http";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Loading from "../Loading";

const InternLeaveApplications = () => {
  const { user } = useSelector((state) => state.authSlice);
  const [type, setType] = useState();
  const [status, setStatus] = useState();
  const [appliedDate, setAppliedDate] = useState();
  const [applications, setApplications] = useState();
  const history = useHistory();

  useEffect(() => {
    const obj = {
      applicantID: user.id,
    };

    const fetchData = async () => {
      const res = await viewInternLeaveApplications(obj);
      const { data } = res;
      setApplications(data);
    };
    fetchData();
  }, [user.id]);

  const searchLeaveApplications = async () => {
    const obj = {
      applicantID: user.id,
    };

    if (type) {
      obj["type"] = type;
    }
    if (status) {
      obj["adminResponse"] = status;
    }
    if (appliedDate) {
      obj["appliedDate"] = appliedDate;
    }

    const res = await viewInternLeaveApplications(obj);
    const { data } = res;
    setApplications(data);

    setAppliedDate("");
    setType("");
    setStatus("");
  };

  return (
    <>
      {applications ? (
        <div className="main-content">
          <section className="section">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4>Leave Applications</h4>
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center align-items-center w-100 gap-2">
              <div className="form-group col-md-2 col-12 mb-2">
                <label>Leave Type</label>
                <select
                  name="type"
                  onChange={(e) => setType(e.target.value)}
                  className="form-control select2 w-100">
                  <option>Select</option>
                  <option>Half day</option>
                  <option>Full Day</option>
                </select>
              </div>

              <div className="form-group col-md-2 col-12 mb-2">
                <label>Status</label>
                <select
                  name="type"
                  onChange={(e) => setStatus(e.target.value)}
                  className="form-control select2 w-100">
                  <option>Select</option>
                  <option>Pending</option>
                  <option>Approved</option>
                  <option>Rejected</option>
                </select>
              </div>

              <div className="form-group col-md-4 col-12 mb-2">
                <label>Applied Date</label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <div className="input-group-text">
                      <i className="fa fa-calendar"></i>
                    </div>
                  </div>
                  <input
                    onChange={(e) => setAppliedDate(e.target.value)}
                    type="date"
                    id="startDate"
                    name="startDate"
                    className="form-control"
                  />
                </div>
              </div>

              <button
                onClick={searchLeaveApplications}
                className="btn btn-lg btn-primary col-md col-12 mt-2">
                Search
              </button>
            </div>
          </section>
          <div className="table-responsive mt-3">
            <table className="table table-striped table-md center-text">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Type</th>
                  <th>Title</th>
                  <th>Applied Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody className="sidebar-wrapper">
                {applications?.map((application, idx) => (
                  <tr
                    className="hover-effect"
                    key={application._id}
                    onClick={() =>
                      history.push(
                        `/intern/userLeaveApplications/${application._id}`
                      )
                    }>
                    <td>{idx + 1}</td>
                    <td>{application.type}</td>
                    <td>{application.title}</td>
                    <td>
                      {new Date(application?.appliedDate)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")}
                    </td>
                    <td
                      className={`${
                        !application.adminResponse ||
                        application.adminResponse?.toLowerCase() === "pending"
                          ? "text-warning"
                          : application.adminResponse?.toLowerCase() ===
                            "rejected"
                          ? "text-danger"
                          : "text-success"
                      }`}>
                      {!application.adminResponse ||
                      application.adminResponse?.toLowerCase() === "pending"
                        ? "Pending"
                        : application.adminResponse?.toLowerCase() ===
                          "rejected"
                        ? "Rejected"
                        : "Approved"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default InternLeaveApplications;
